type FrontendExpectedErrorRule = {
  code?: string
  codePattern?: RegExp
  operationPattern?: RegExp
}

type FrontendExpectedErrorsConfig = {
  common: FrontendExpectedErrorRule[]
  // The key is the URL path segment extracted by getDomainFromPathname().
  // e.g. /partners/:id/warehouses/:id/<domain>/... → 'campaigns'
  // This is the route segment, NOT the domains/ folder name.
  byDomain: Record<string, FrontendExpectedErrorRule[]>
}

export const expectedErrorsConfig: FrontendExpectedErrorsConfig = {
  common: [{ code: 'UNDETERMINED_ACCOUNT' }],
  byDomain: {
    campaigns: [
      // Backend validation errors (budget limits, spend validation, etc.) from CreateValueGrantPolicy
      // are expected business logic — the UI shows a validation modal and retries with skip-validation.
      { codePattern: /_validation/i, operationPattern: /ValueGrantPolicy/ },
    ],
    'orders-operational-dashboard': [
      // Boba OfferService rejects unenrolled retailers with INVALID_ARGUMENT. The UI gracefully
      // falls back to empty discount data, so this is expected business logic, not an error.
      { code: 'INVALID_ARGUMENT', operationPattern: /GetOrderDiscountInfo/ },
    ],
  },
}
